import i18next from "i18next";

/**
 * Translate given string using i18next.
 * @param keyToTranslate Key of the Translation Json
 */
export const translate = (keyToTranslate: string) => i18next.t(keyToTranslate);
